$(window).on('load', () => {
    let observerConfig = {
        root: null,
        rootMargin: '0px 0px -100px',
        threshold: 0,
    };

    if (window.matchMedia('(min-width:992px)').matches) {
        observerConfig = {
            root: null,
            rootMargin: '0px 0px -100px',
            threshold: 0,
        };
    }

    let previousY = 0;
    let previousRatio = 0;
    // eslint-disable-next-line no-undef
    const observer = new IntersectionObserver(((entries) => {
        entries.forEach((entry) => {
            const currentY = entry.boundingClientRect.y;
            const currentRatio = entry.intersectionRatio;
            const { isIntersecting } = entry;
            const element = entry.target;
            const elementData = element.dataset;

            if (isIntersecting === true) {
                element.classList.add('element-seen');
            }

            if (
                typeof elementData.animationClass !== 'undefined'
                && element.classList.contains(elementData.animationClass) === false
                && isIntersecting === true
            ) {
                let delay = 0;
                if (typeof elementData.animationDelay !== 'undefined') {
                    delay = parseInt(elementData.animationDelay);
                }
                setTimeout(() => {
                    element.classList.add(elementData.animationClass);
                }, delay);
            }

            element.classList.remove('outview-top', 'inview-top', 'inview-bottom', 'outview-bottom');
            // Scrolling up
            if (currentY < previousY) {
                const className = (currentRatio >= previousRatio) ? 'inview-top' : 'outview-top';
                element.classList.add(className);

                // Scrolling down
            } else if (currentY > previousY) {
                const className = (currentRatio <= previousRatio) ? 'outview-bottom' : 'inview-bottom';
                element.classList.add(className);
            }

            previousY = currentY;
            previousRatio = currentRatio;
        });
    }), observerConfig);

    // let elements = document.querySelectorAll('.frame-container');
    // for (let i = 0; i < elements.length; i++) {
    //   observer.observe(elements[i]);
    // }

    setTimeout(() => {
        const elements = document.querySelectorAll('.frame-container, .ce-location-item, .ce-f-wrapper');
        for (let i = 0; i < elements.length; i += 1) {
            observer.observe(elements[i]);
        }
    }, 100);
});
